import { Link } from "react-router-dom";

// material-ui
import { ButtonBase } from "@mui/material";

// project imports
// import config from "../../config";
// import Logo from "../../assets/images/logo/AiLogo.svg";
import Logo from "../../assets/images/AiImage.svg";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
  <ButtonBase
    disableRipple
    component={Link}
    to={"/aiapp"}
    sx={{ marginRight: "23px" }}
  >
    <img src={Logo} width="100%" height={"auto"} />
  </ButtonBase>
);

export default LogoSection;
